import { loadCompanyProfiles, deleteProfile, createProfile, updateProfile } from 'actions/profile';
import { createReducerAsync } from 'redux-act-async';

const reducer = createReducerAsync(loadCompanyProfiles);

reducer.on(
  deleteProfile.ok,
  (state, payload) => ({
    ...state,
    data: state.data.filter(
      ({ id }) => id !== payload.request[0].userId
    )
  })
);

reducer.on(
  updateProfile.ok,
  (state, payload) => ({
    ...state,
    data: state.data && state.data.map(
      (profile) => {
        return profile.id === payload.request[0].userId
          ? payload.response
          : profile;
      }
    )
  })
);

reducer.on(
  createProfile.ok,
  (state, payload) => ({
    ...state,
    data: [...state.data, payload.response]
  })
);

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/profiles.js